import { createContext, useContext, useEffect } from 'react'
import { getMe, logout as logoutApi } from '@/services/authService'
import { setUser, clearAuth } from '@/store/slices/authSlice'
import { useAppDispatch, useAppSelector } from '@/store/hooks'
import type { AuthenticatedUser } from '@/types'

interface AuthContextValue {
  user: AuthenticatedUser | null
  loading: boolean
  logout: () => Promise<void>
}

const AuthContext = createContext<AuthContextValue | null>(null)

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const dispatch = useAppDispatch()
  const user = useAppSelector((state) => state.auth.user)
  const isLoading = useAppSelector((state) => state.auth.isLoading)

  useEffect(() => {
    getMe()
      .then((res) => dispatch(setUser(res.data)))
      .catch(() => dispatch(clearAuth()))
  }, [dispatch])

  const logout = async () => {
    await logoutApi()
    dispatch(clearAuth())
  }

  return (
    <AuthContext.Provider value={{ user, loading: isLoading, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be used within AuthProvider')
  return ctx
}
